import React from 'react';

export default class LiveErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error('[LiveErrorBoundary]', error);
  }

  handleRetry = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="nt-desktop nt-v1" style={{ padding: 24, minHeight: '100vh' }}>
        <div className="card" style={{ maxWidth: 560, margin: '40px auto' }}>
          <h1 style={{ marginTop: 0 }}>Normal Trading V1</h1>
          <p>UI hit an error — your backend bot is still running on disk.</p>
          <p style={{ color: '#f87171', fontSize: '0.9rem' }}>{error.message || 'Unknown error'}</p>
          <button type="button" className="nt-v1-btn primary" onClick={this.handleRetry}>
            Reload screen
          </button>
        </div>
      </div>
    );
  }
}
